import { render, staticRenderFns } from "./SegundaVia.vue?vue&type=template&id=0916f762&scoped=true"
import script from "./SegundaVia.vue?vue&type=script&lang=js"
export * from "./SegundaVia.vue?vue&type=script&lang=js"
import style0 from "./SegundaVia.vue?vue&type=style&index=0&id=0916f762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916f762",
  null
  
)

export default component.exports